<template>
  <div id="app">
    <div class="backBA colorW fix-menu shipeis">
      <Row class="code-row-bg shipei">
        <Col span="8" offset="3" class="alignCenter" style="padding-top: 8px; position:relative">
          <img
            class="Logo norme"
            src="/static/image/logo.png"
            style="width: 160px;display: table;margin-right: auto;position:absolute;"
          />
        </Col>
        <Col span="12">
          <Row class="code-row-bg">
            <Col span="3" style class="tjmb" v-for="(item,index) in indexList" :key="index">
              <router-link
                :to="(item.linkTo)"
                tag="div"
                class="colorW"
                style="cursor:pointer"
                @click.native="clickMenu(index)"
              >
                <div
                  :id="item.value"
                  :class="{indexActive:item.indexActive,indexActives:item.indexActives}"
                  style="text-align: center;font-size: 15px;"
                  @mouseenter="enter(index)"
                >{{item.title}}</div>
              </router-link>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
    <div
      id="chanpinList"
      class="backBA50 colorW fix-pos"
      :class="{fixMmenuN:fix_menu_n,fixMmenuNs:fix_menu_ns,displayNone:isDisplayNone}"
    >
      <Row type="flex" justify="center" class="code-row-bg">
        <Col span="2" v-for="(item,index) in chanpinList" style="padding-top: 10px;" :key="index">
          <router-link
            :to="(item.linkTo)"
            tag="div"
            class="colorW"
            style="cursor:pointer"
            @click.native="clickTwoMenu(index)"
          >
            <div @mouseenter="chanpinEnter(index)">
              <div class="alignCenter">
                <img :src="item.icon" style="width: 30px;height: 30px;" />
              </div>
              <div
                class="alignCenter"
                :class="{colorBA:item.isColorBA,colorBAs:item.isColorBAs}"
              >{{item.title}}</div>
            </div>
          </router-link>
        </Col>
      </Row>
    </div>
    <div
      id="guanyuList"
      class="backBA50 colorW fix-pos"
      :class="{fixMmenuN1:fix_menu_n1,fixMmenuNs1:fix_menu_ns1,displayNone:isDisplayNone1}"
    >
      <Row type="flex" justify="center" class="code-row-bg">
        <Col span="2" style="padding-top: 10px;" v-for="(item,index) in aboutList" :key="index">
          <router-link
            :to="(item.linkTo)"
            tag="div"
            style="cursor:pointer"
            class="colorW"
            @click.native="clickAbout(index)"
          >
            <div @mouseenter="aboutEnter(index)">
              <div class="alignCenter">
                <img :src="item.icon" style="width: 30px;height: 30px;" />
              </div>
              <div
                class="alignCenter"
                :class="{colorBA:item.isColorBA,colorBAs:item.isColorBAs}"
              >{{item.title}}</div>
            </div>
          </router-link>
        </Col>
      </Row>
    </div>
    <router-view @mouseenter.native="enters()" />
    <div style="background: #222222;padding:50px 0">
      <!-- <Row type="flex" justify="center" class="code-row-bg">
        <Col span="3">
          <div class="about-title">关于我们</div>
          <div class="sub-about-title">
            <router-link to="/about" @click.native="clickAbout(0)">
              <span class="curPoin" style="color: #666666;">公司简介</span>
            </router-link>
          </div>
          <div class="sub-about-title">
            <router-link to="/wenhua" @click.native="clickAbout(1)">
              <span class="curPoin" style="color: #666666;">企业文化</span>
            </router-link>
          </div>
          <div class="sub-about-title">
            <router-link to="/increment" @click.native="clickMenu(6)">
              <span class="curPoin" style="color: #666666;">售后服务</span>
            </router-link>
          </div>
          <div class="sub-about-title">
            <router-link to="/lianxi" @click.native="clickAbout(4)">
              <span class="curPoin" style="color: #666666;">联系我们</span>
            </router-link>
          </div>
        </Col>
        <Col span="3">
          <div class="about-title">服务项目</div>
          <div class="sub-about-title">
            <router-link to="/wangzhan" @click.native="clickTwoMenu(1)">
              <span class="curPoin" style="color: #666666;">网站建设</span>
            </router-link>
          </div>
          <div class="sub-about-title">
            <router-link to="/apps" @click.native="clickTwoMenu(0)">
              <span class="curPoin" style="color: #666666;">APP开发</span>
            </router-link>
          </div>
          <div class="sub-about-title">
            <router-link to="/weixin" @click.native="clickTwoMenu(2)">
              <span class="curPoin" style="color: #666666;">微信小程序</span>
            </router-link>
          </div>
          <div class="sub-about-title">
            <router-link to="/sheiji" @click.native="clickTwoMenu(4)">
              <span class="curPoin" style="color: #666666;">UI设计</span>
            </router-link>
          </div>
          <div class="sub-about-title">
            <router-link to="/sysj" @click.native="clickTwoMenu(5)">
              <span class="curPoin" style="color: #666666;">商业设计</span>
            </router-link>
          </div>
        </Col>
        <Col span="3">
          <div class="about-title">新闻中心</div>
          <div class="sub-about-title">
            <router-link to="/news" @click.native="clickMenu(5)">
              <span class="curPoin" style="color: #666666;">行业新闻</span>
            </router-link>
          </div>
          <div class="sub-about-title">
            <router-link to="/news" @click.native="cheker()">
              <span class="curPoin" style="color: #666666;">简云课堂</span>
            </router-link>
          </div>
          <div class="sub-about-title">
            <router-link to="/programme" @click.native="clickMenu(2)">
              <span class="curPoin" style="color: #666666;">解决方案</span>
            </router-link>
          </div>
        </Col>
        <Col span="3">
          <div class="about-title">友情链接</div>
          <div class="sub-about-title">
            <a class="asstext" href="https://mp.weixin.qq.com/" target="_blank">微信公众平台</a>
          </div>
          <div class="sub-about-title">
            <a class="asstext" href="https://www.huaweicloud.com/" target="_blank">华为云</a>
          </div>
          <div class="sub-about-title">
            <a class="asstext" href="https://www.aliyun.com/" target="_blank">阿里云</a>
          </div>
          <div class="sub-about-title">
            <a class="asstext" href="https://cloud.tencent.com/?fromSource=gwzcw.2212127.2212127.2212127&utm_medium=cpd&utm_id=gwzcw.2212127.2212127.2212127" target="_blank">腾讯云</a>
          </div>
          <div class="sub-about-title">
            <a class="asstext" href="https://open.weixin.qq.com/" target="_blank">微信开放平台</a>
          </div>
          <div class="sub-about-title">
            <a class="asstext" href="https://pay.weixin.qq.com/index.php/core/home/login?return_url=%2F" target="_blank">微信支付</a>
          </div>
          <div class="sub-about-title">
            <a class="asstext" href="https://www.alipay.com/" target="_blank">支付宝支付</a>
          </div>
        </Col>
      </Row>
      <div style="height: 2px;background: #999999;margin: 20px 0 15px 0;"></div>-->
      <div class="link">
        <div class="link-title">友情链接</div>
        <div class="link-title">
          <a class="asstext" href="https://mp.weixin.qq.com/" target="_blank">微信公众平台</a>
        </div>
        <div class="link-title">
          <a class="asstext" href="https://open.weixin.qq.com/" target="_blank">微信开放平台</a>
        </div>
        <div class="link-title">
          <a class="asstext" href="https://www.huaweicloud.com/" target="_blank">华为云</a>
        </div>
        <div class="link-title">
          <a class="asstext" href="https://www.aliyun.com/" target="_blank">阿里云</a>
        </div>
        <div class="link-title">
          <a
            class="asstext"
            href="https://cloud.tencent.com/?fromSource=gwzcw.2212127.2212127.2212127&utm_medium=cpd&utm_id=gwzcw.2212127.2212127.2212127"
            target="_blank"
          >腾讯云</a>
        </div>
        <div class="link-title">
          <a
            class="asstext"
            href="https://pay.weixin.qq.com/index.php/core/home/login?return_url=%2F"
            target="_blank"
          >微信支付</a>
        </div>
        <div class="link-title">
          <a class="asstext" href="https://www.alipay.com/" target="_blank">支付宝支付</a>
        </div>
      </div>
      <div class="alignCenter" style="color: #666666;padding-top: 20px">
        Copyright © 2018-2027 河南简云网络科技有限公司 版权所有&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <a
          @click="record"
          style="color: #666666;cursor:pointer"
          id="_active"
        >
          技术支持：简云科技-助你简便进入云时代 | 豫ICP备18014626号-1 | 豫ICP备18014626号-3
        </a>
      </div>
      <!-- <div class="alignCenter" style="padding-top: 20px;padding-bottom: 20px;color: #666666;">
        <a @click="record" style="color: #666666;cursor:pointer" id="_active">
          技术支持：简云科技-助你简便进入云时代 |
          豫ICP备18014626号
        </a>
      </div>-->
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import Swiper from "swiper";

var img_url_i = "";
// if (window.location.host.slice(0, 5) === "local") {
//   img_url_i = "..";
// } else {
//   img_url_i = "/jianyunPC";
// }
let chanpinListVar = [
  {
    title: "APP开发",
    value: "app",
    linkTo: "/apps",
    icon: img_url_i + "/static/image/app1.png",
    isColorBA: false,
    isColorBAs: false
  },
  {
    title: "网站建设",
    value: "wangzhan",
    linkTo: "/wangzhan",
    icon: img_url_i + "/static/image/wangzhan1.png",
    isColorBA: false,
    isColorBAs: false
  },
  {
    title: "微信小程序",
    value: "weixin",
    linkTo: "/weixin",
    icon: img_url_i + "/static/image/weixin1.png",
    isColorBA: false,
    isColorBAs: false
  },
  {
    title: "H5开发",
    value: "htmls",
    linkTo: "/htmls",
    icon: img_url_i + "/static/image/h51.png",
    isColorBA: false,
    isColorBAs: false
  },
  {
    title: "UI设计",
    value: "sheiji",
    linkTo: "/sheiji",
    icon: img_url_i + "/static/image/sheji1.png",
    isColorBA: false,
    isColorBAs: false
  },
  {
    title: "商业设计",
    value: "sysj1",
    linkTo: "/sysj",
    icon: "../../static/image/sy1.png",
    isColorBA: false,
    isColorBAs: false
  }
  // {
  //   title: "模板系统",
  //   value: "moban",
  //   linkTo: "",
  //   icon: img_url_i + "/static/image/moban1.png",
  //   isColorBA: false,
  //   isColorBAs: false
  // }
];
let aboutListVar = [
  {
    title: "行业背景",
    value: "chuxin",
    linkTo: "/about",
    icon: "../../static/image/chuxin.png",
    isColorBA: false,
    isColorBAs: false
  },
  {
    title: "公司简介",
    value: "gongsijianjie",
    linkTo: "/Companyprofile",
    icon: img_url_i + "/static/image/jianjie1.png",
    isColorBA: false,
    isColorBAs: false
  },
  {
    title: "发展历程",
    value: "course1",
    linkTo: "/course",
    icon: "../../static/image/course.png",
    isColorBA: false,
    isColorBAs: false
  },
  {
    title: "联系我们",
    value: "lianxiwomen",
    linkTo: "/lianxi",
    icon: img_url_i + "/static/image/lianxiwomen1.png",
    isColorBA: false,
    isColorBAs: false
  },
  {
    title: "企业文化",
    value: "qiyewenhua",
    linkTo: "/wenhua",
    icon: img_url_i + "/static/image/qiyewenhua1.png",
    isColorBA: false,
    isColorBAs: false
  },
  {
    title: "办公环境",
    value: "bangonghuanjing",
    linkTo: "/huanjing",
    icon: img_url_i + "/static/image/bangonghuanjing1.png",
    isColorBA: false,
    isColorBAs: false
  },
  {
    title: "加入我们",
    value: "jiaruwomen",
    linkTo: "/jiaru",
    icon: img_url_i + "/static/image/jiaruwomen1.png",
    isColorBA: false,
    isColorBAs: false
  }
];

require("./assets/css/main.css");
export default {
  name: "App",
  data() {
    return {
      twoMenu: -1,
      fix_menu_n: false,
      fix_menu_ns: true,
      fix_menu_n1: false,
      fix_menu_ns1: true,
      isDisplayNone: true,
      isDisplayNone1: true,
      menuValue: "",
      enterValue: "",
      indexList: [
        {
          title: "首页",
          value: "shouye",
          indexActive: false,
          indexActives: true,
          linkTo: "/"
        },
        // {title: "产品服务", value: "chanpin", indexActive: false, indexActives: false, linkTo: "/product"},
        {
          title: "定制服务",
          value: "chanpin",
          indexActive: false,
          indexActives: false,
          linkTo: ""
        },
        {
          title: "案例中心",
          value: "anli",
          indexActive: false,
          indexActives: false,
          linkTo: "/case"
        },
        {
          title: "解决方案",
          value: "jiejue",
          indexActive: false,
          indexActives: false,
          linkTo: "/programme"
        },
        {
          title: "模板系统",
          value: "moban",
          linkTo: "/moban",
          icon: img_url_i + "/static/image/moban1.png",
          indexActive: false,
          indexActives: false,
          isColorBAs: false
        },
        {
          title: "关于我们",
          value: "guanyu",
          indexActive: false,
          indexActives: false,
          linkTo: ""
        },
        // {title: "关于我们", value: "guanyu", indexActive: false, indexActives: false, linkTo: "/about"},
        {
          title: "新闻中心",
          value: "xinwen",
          indexActive: false,
          indexActives: false,
          linkTo: "/news"
        },
        {
          title: "服务标准",
          value: "zengzhi",
          indexActive: false,
          indexActives: false,
          linkTo: "/increment"
        },
        {
          title: "帮助中心",
          value: "help",
          indexActive: false,
          indexActives: false,
          linkTo: "/help_content"
        }
      ],
      chanpinList: chanpinListVar,
      chanpinListLocal: chanpinListVar,
      aboutList: aboutListVar,
      aboutListLocal: aboutListVar
    };
  },
  created() {
    // this.chanpin();
    // this.about();
    // this.get_foot_information()
    var that = this;
    var indexListStatus = window.sessionStorage.getItem("indexListStatus");
    if (indexListStatus) {
      indexListStatus = JSON.parse(indexListStatus);
      that.indexList = indexListStatus;

      indexListStatus.map(function(item, i) {
        if (item.indexActives) {
          if (i == 1) {
            var k = window.sessionStorage.getItem("indexListStatus_index");
            var chanpinList = [];
            that.chanpinList.map(function(item_list1) {
              item_list1.isColorBAs = false;
              chanpinList.push(item_list1);
            });
            chanpinList[k].isColorBAs = true;
            var newImg = chanpinList[k].icon.split("1.png")[0] + ".png";
            chanpinList[k].icon = newImg;
            that.chanpinList = chanpinList;
          }
          if (i == 4) {
            var k = window.sessionStorage.getItem("indexListStatus_index");
            var aboutList = [];
            that.aboutList.map(function(item_list2) {
              item_list2.isColorBAs = false;
              aboutList.push(item_list2);
            });
            aboutList[k].isColorBAs = true;
            var newImg = aboutList[k].icon.split("1.png")[0] + ".png";
            aboutList[k].icon = newImg;
            that.aboutList = aboutList;
          }
        }
      });
    }
  },
  methods: {
    //获取底部信息
    get_foot_information() {
      var that = this;
      var url =
        that.baseUrl + "/jianyun/api/mall.php?c=about_us/getCompanyInfo";
      that.axios
        .get(url, {
          params: {
            type: 4
          }
        })
        .then(res => {
          if (res.data.success) {
            console.log(res.data.data);
          } else {
            this.$Message.warning(res.data.msg);
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    cheker() {
      // this.$parent.clickNews(1);
      this.clickMenu(5);
    },
    record() {
      window.location.href = "https://beian.miit.gov.cn/";
    },
    enter(index) {
      let that = this;
      let num = that.twoMenu;
      let menuVal = that.menuValue;
      that.enterValue = that.indexList[index].value;
      that.indexList.map(function(item) {
        item.indexActive = false;
      });
      if (menuVal === "chanpin") {
        if (num >= 0) {
          that.chanpinList[num].icon = that.chanpinList[num].icon.replace(
            /1.png/g,
            ".png"
          );
        }
      } else if (menuVal === "about") {
        if (num >= 0) {
          that.aboutList[num].icon = that.aboutList[num].icon.replace(
            /1.png/g,
            ".png"
          );
        }
      }
      that.indexList[index].indexActive = true;
      if (that.indexList[index].value === "chanpin") {
        that.fix_menu_n = true;
        that.fix_menu_ns = false;
        that.isDisplayNone1 = true;
        that.isDisplayNone = false;
      } else {
        that.fix_menu_ns = true;
        that.fix_menu_n = false;
      }
      if (that.indexList[index].value === "guanyu") {
        that.fix_menu_n1 = true;
        that.fix_menu_ns1 = false;
        that.isDisplayNone1 = false;
        that.isDisplayNone = true;
      } else {
        that.fix_menu_ns1 = true;
        that.fix_menu_n1 = false;
      }

      that.chanpinList = this.chanpinListLocal;
      that.aboutList = this.aboutListLocal;
      // console.log(JSON.stringify(this.aboutListLocal));
      var k = window.sessionStorage.getItem("indexListStatus_index");
      if (k >= 0) {
        if (index == 1) {
          this.chanpinEnter(999);
        }
        if (index == 4) {
          this.aboutEnter(999);
        }
      }
    },
    chanpinEnter(index) {
      this.chanpinList = chanpinListVar;
      this.aboutList = aboutListVar;
      var chanpinList = chanpinListVar; //每次获取点击后的状态值
      var k = window.sessionStorage.getItem("indexListStatus_index");

      var indexListStatus = window.sessionStorage.getItem("indexListStatus");
      var navListIndex = "";
      if (indexListStatus) {
        indexListStatus = JSON.parse(indexListStatus);
        indexListStatus.map(function(item, i) {
          if (item.indexActives) {
            navListIndex = i;
          }
        });
      }
      let that = this;
      // if (condition) {
      // }
      let num = that.twoMenu;
      let menuVal = that.menuValue;
      chanpinList.map(function(item) {
        item.isColorBA = false;
        item.icon = item.icon
          .replace(/1.png/g, ".png")
          .replace(/.png/g, "1.png");
      });
      if (index < chanpinList.length) {
        chanpinList[index].icon = chanpinList[index].icon.replace(
          /1.png/g,
          ".png"
        );
        chanpinList[index].isColorBA = true;
      }

      if (navListIndex == 1) {
        chanpinList[k].icon = chanpinList[k].icon.replace(/1.png/g, ".png");
        chanpinList[k].isColorBA = true;
      }

      // if (menuVal === "chanpin") {
      //   if (num >= 0) {
      //     that.chanpinList[num].icon = that.chanpinList[num].icon.replace(
      //       /1.png/g,
      //       ".png"
      //     );
      //   }
      // } else if (menuVal === "about") {
      //   if (num >= 0) {
      //     that.aboutList[num].icon = that.aboutList[num].icon.replace(
      //       /1.png/g,
      //       ".png"
      //     );
      //   }
      // }
      that.chanpinList = chanpinList;
    },
    aboutEnter(index) {
      this.chanpinList = chanpinListVar;
      this.aboutList = aboutListVar;
      var aboutList = aboutListVar; //头大，这个值，只有点击才会改变，，现在为什么一直在变
      var k = window.sessionStorage.getItem("indexListStatus_index");

      var indexListStatus = window.sessionStorage.getItem("indexListStatus");
      var navListIndex = "";
      if (indexListStatus) {
        indexListStatus = JSON.parse(indexListStatus);
        indexListStatus.map(function(item, i) {
          if (item.indexActives) {
            navListIndex = i;
          }
        });
      }

      let that = this;
      let num = that.twoMenu;
      let menuVal = that.menuValue;

      aboutList.map(function(item, index) {
        item.isColorBA = false;
        item.icon = item.icon
          .replace(/1.png/g, ".png")
          .replace(/.png/g, "1.png");
      });
      if (index < aboutList.length) {
        aboutList[index].icon = aboutList[index].icon.replace(/1.png/g, ".png");
        aboutList[index].isColorBA = true;
      }
      if (navListIndex == 4) {
        aboutList[k].icon = aboutList[k].icon.replace(/1.png/g, ".png");
        aboutList[k].isColorBA = true;
      }
      // console.log(JSON.stringify(this.aboutListLocal));
      // if (menuVal === "chanpin") {
      //   if (num >= 0) {
      //     chanpinList[num].icon = chanpinList[num].icon.replace(
      //       /1.png/g,
      //       ".png"
      //     );
      //   }
      // } else if (menuVal === "about") {
      //   if (num >= 0) {
      //     aboutList[num].icon = aboutList[num].icon.replace(/1.png/g, ".png");
      //   }
      // }
      that.aboutList = aboutList;
    },

    clickMenu(index) {
      let that = this;
      localStorage.setItem("nav1", index);
      that.twoMenu = -1;
      if (that.indexList[index].value === "moban") {
        window.location.hash = "/moban";
      } else if (
        that.indexList[index].value === "chanpin" ||
        that.indexList[index].value === "guanyu"
      ) {
        return "";
      }
      that.chanpinList.map(function(item) {
        item.isColorBA = false;
        item.isColorBAs = false;
        if (!(item.icon.indexOf("1.png") !== -1)) {
          item.icon = item.icon.replace(/.png/g, "1.png");
        }
      });
      that.aboutList.map(function(item) {
        item.isColorBA = false;
        item.isColorBAs = false;
        if (!(item.icon.indexOf("1.png") !== -1)) {
          item.icon = item.icon.replace(/.png/g, "1.png");
        }
      });
      that.indexList.map(function(item) {
        item.indexActives = false;
      });

      // that.indexList[index].indexActives = true;
      // localStorage.removeItem("chanpin");
      this.changeNavStatus(index);
    },
    clickTwoMenu(index) {
      // localStorage.setItem("chanpin", index);
      let that = this;
      if (that.chanpinList[index].value === "moban") {
        return window.open("http://www.jianyunkeji.net/");
      } else {
        that.twoMenu = index;
        that.menuValue = "chanpin";
        that.chanpinList.map(function(item) {
          item.isColorBAs = false;
          if (!(item.icon.indexOf("1.png") !== -1)) {
            item.icon = item.icon.replace(/.png/g, "1.png");
          }
        });
        that.aboutList.map(function(item) {
          item.isColorBAs = false;
          if (!(item.icon.indexOf("1.png") !== -1)) {
            item.icon = item.icon.replace(/.png/g, "1.png");
          }
        });
        that.chanpinList[index].isColorBAs = true;
        that.chanpinList[index].icon = that.chanpinList[index].icon.replace(
          /1.png/g,
          ".png"
        );
        // that.indexList.map(function(item) {
        //   item.indexActives = false;
        // });
        // that.indexList[1].indexActives = true;
        this.changeNavStatus(1, index);
      }
    },
    clickAbout(index) {
      // localStorage.setItem("about", index);

      let that = this;
      that.twoMenu = index;
      that.menuValue = "about";
      that.aboutList.map(function(item) {
        item.isColorBAs = false;
        item.icon = item.icon
          .replace(/1.png/g, ".png")
          .replace(/.png/g, "1.png");
        // if (!(item.icon.indexOf("1.png") !== -1)) {
        //   item.icon = item.icon.replace(/.png/g, "1.png");
        // }
      });
      that.chanpinList.map(function(item) {
        item.isColorBAs = false;
        if (!(item.icon.indexOf("1.png") !== -1)) {
          item.icon = item.icon.replace(/.png/g, "1.png");
        }
      });
      that.aboutList[index].isColorBAs = true;
      that.aboutList[index].icon = that.aboutList[index].icon.replace(
        /1.png/g,
        ".png"
      );
      // that.indexList.map(function(item) {
      //   item.indexActives = false;
      // });
      // localStorage.removeItem("chanpin");
      this.changeNavStatus(5, index);
    },
    enters() {
      let that = this;
      let menuVal = that.enterValue;
      if (menuVal === "chanpin") {
        that.indexList.map(function(item) {
          item.indexActive = false;
          that.fix_menu_ns = true;
          that.fix_menu_n = false;
          var times = setTimeout(function() {
            that.isDisplayNone1 = true;
            that.isDisplayNone = true;
          }, 300);
        });
      } else if (menuVal === "guanyu") {
        that.indexList.map(function(item) {
          item.indexActive = false;
          that.fix_menu_ns1 = true;
          that.fix_menu_n1 = false;
          var times = setTimeout(function() {
            that.isDisplayNone1 = true;
            that.isDisplayNone = true;
          }, 300);
        });
      } else {
        that.indexList.map(function(item) {
          item.indexActive = false;
        });
      }
    },
    // //父导航
    // navs() {
    //   let that = this;
    //   var locas = window.location.hash;
    //   var newlocas = locas.slice(1);
    //   if (newlocas == that.indexList[localStorage.nav1].linkTo) {
    //     that.indexList[localStorage.nav1].indexActives = true;
    //   }
    //   if (localStorage.nav1 == 0) {
    //     that.indexList[0].indexActives = true;
    //   } else {
    //     that.indexList[0].indexActives = false;
    //   }
    // },

    //产品导航
    chanpin() {
      // this.clickTwoMenu(localStorage.chanpin);
      this.changeNavStatus(3);
      // let that = this;
      // var locas = window.location.hash;
      // var newlocas = locas.slice(1);
      // if (newlocas == that.chanpinList[localStorage.chanpin].linkTo) {
      //   that.chanpinList[localStorage.chanpin].isColorBAs = true;
      //   that.indexList[1].indexActives = true;
      //   that.indexList[0].indexActives = false;
      // }
      // console.log(that.chanpinList[localStorage.chanpin].icon);
    },
    //关于导航
    about() {
      // this.clickAbout(localStorage.about);
      // let that = this;
      // var locas = window.location.hash;
      // var newlocas = locas.slice(1);
      // if (newlocas == that.aboutList[localStorage.about].linkTo) {
      //   that.aboutList[localStorage.about].isColorBAs = true;
      //   that.indexList[0].indexActives = false;
      //   that.indexList[4].indexActives = true;
      // }
    },
    changeNavStatus(i, k) {
      console.log(i);
      console.log(k);
      var indexList = this.indexList;
      var that = this;
      indexList.map(function(item) {
        item.indexActives = false;
        return item;
      });
      indexList[i].indexActives = true;
      this.indexList = indexList;
      indexList = JSON.stringify(indexList);
      window.sessionStorage.setItem("indexListStatus", indexList);

      // 重置所有，设置当前
      var chanpinListNew = chanpinListVar;
      var aboutListNew = aboutListVar;

      if (i == 1) {
        window.sessionStorage.setItem("indexListStatus_index", k);
        chanpinListNew[k].isColorBAs = true;
        chanpinListNew[k].icon = chanpinListNew[k].icon.replace(
          /1.png/g,
          ".png"
        );
      }
      if (i == 5) {
        window.sessionStorage.setItem("indexListStatus_index", k);
        aboutListNew[k].isColorBAs = true;
        aboutListNew[k].icon = aboutListNew[k].icon.replace(/1.png/g, ".png");
      }

      // console.log(JSON.stringify(chanpinListNew));
      // console.log(JSON.stringify(aboutListNew));
      that.chanpinList = chanpinListNew;
      that.aboutList = aboutListNew;
      that.chanpinListLocal = chanpinListNew;
      that.aboutListLocal = aboutListNew;
      if (i == 1) {
        this.chanpinEnter(k);
      }
      if (i == 5) {
        this.aboutEnter(k);
      }
    }
  }
};
</script>
<style>
.link {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 800px;
  margin: auto;
}
.link-title {
  font-size: 16px;
}
.link-title:nth-child(1) {
  color: #fff;
}
@media (max-width: 1200px) {
  .shipeis {
    width: 1200px;
  }
  .shipei {
    width: 1200px;
  }
}
.ivu-col-span-3 {
  width: 10.5% !important;
}
::v-deep .tjmb {
  width: 70px;
  margin-left: 25px;
}
::v-deep .tjmb:nth-child(1) {
  margin-left: 0px;
}
.asstext {
  color: rgb(102, 102, 102);
}
.asstext:hover {
  color: white;
}
#_active:hover {
  color: #009900 !important;
}

.Logo {
  animation-name: myfirst;
  animation-duration: 2s;
  animation-timing-function: linear;
  /* animation-delay: 2s; */
  /* animation-iteration-count: infinite; */
  animation-direction: alternate;
  animation-play-state: running;
}
@keyframes myfirst {
  0% {
    left: -1000px;
  }
  25% {
    left: -800px;
  }
  50% {
    left: -500px;
  }
  75% {
    left: -100px;
  }
  100% {
    left: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue